import { render, staticRenderFns } from "./RegisterVerifyTab.vue?vue&type=template&id=14146c84&scoped=true&"
import script from "./RegisterVerifyTab.vue?vue&type=script&lang=js&"
export * from "./RegisterVerifyTab.vue?vue&type=script&lang=js&"
import style0 from "./RegisterVerifyTab.vue?vue&type=style&index=0&id=14146c84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14146c84",
  null
  
)

export default component.exports